// extracted by mini-css-extract-plugin
export default {"header":"EventsNavigation_header__xa2Hc","list":"EventsNavigation_list__FQqQp","active":"EventsNavigation_active__fILnq"};